/**
 * This utility class helps to manage the Yext Faqs
 */
import { CustomEvents } from './CustomEvents';
import {emit} from './EventsBus';

class YextFaqUtils {

  constructor() {
    this.readParams();
  }

  get SELECTORS() {
    return {
      input: '[data-yext-input]',
      baseUrl: 'data-base-url',
      apiKey: 'data-api-key',
      experienceKey: 'data-experience-key',
      verticalKey: 'data-vertical-key',
      accountId: 'data-account-id',
      autocompleteURI: 'data-search-uri',
      siteCountry: 'data-site-country',
    }
  }
  get PARAMS() {
    return {
      autocompleteURI: '/accounts/{{accountId}}/search/autocomplete',
      searchURI: '/accounts/{{accountId}}/search/vertical/query',
    }
  }

  // autocomplete sample
  // https://cdn.yextapis.com/v2/accounts/2423009/search/autocomplete
  // ?api_key=73372fd96fe84bd4306a91043923e023&v=20240830&experienceKey=test-faq-and-categories&locale=it&input=come

  // query sample
  // https://cdn.yextapis.com/v2/accounts/me/search/vertical/query
  // ?api_key=73372fd96fe84bd4306a91043923e023&v=20240906&experienceKey=test&verticalKey=faq&locale=it&input=COME+SI+ACQUISTA%3F

  readParams() {
    //
    let params = {}
    params.apikey = document.querySelector('['+this.SELECTORS.apiKey+']').getAttribute(this.SELECTORS.apiKey);
    params.experienceKey = document.querySelector('['+this.SELECTORS.experienceKey+']').getAttribute(this.SELECTORS.experienceKey);
    params.verticalKey = document.querySelector('['+this.SELECTORS.verticalKey+']').getAttribute(this.SELECTORS.verticalKey);
    params.baseUrl = document.querySelector('['+this.SELECTORS.baseUrl+']').getAttribute(this.SELECTORS.baseUrl);
    params.accountId = document.querySelector('['+this.SELECTORS.accountId+']').getAttribute(this.SELECTORS.accountId);
    params.autocompleteURI = document.querySelector('['+this.SELECTORS.autocompleteURI+']').getAttribute(this.SELECTORS.autocompleteURI);
    params.siteCountry = document.querySelector('['+this.SELECTORS.siteCountry+']').getAttribute(this.SELECTORS.siteCountry);
    // for public
    this.params = params;
  }

  getDate() {
    let today = new Date();
    return today.getFullYear()+String(today.getMonth() + 1).padStart(2, '0')+String(today.getDate()).padStart(2, '0');
  }

  buildQS() {
    let qs = '?';
    qs += 'api_key=' + this.params.apikey;
    qs += '&v=' + this.getDate();
    qs += '&locale=' + document.documentElement.getAttribute('lang');
    qs += '&experienceKey=' + this.params.experienceKey;
    qs += '&verticalKey=' + this.params.verticalKey;
    qs += '&limit=10';
    qs += '&filters={"c_site":{"$eq":"'+this.params.siteCountry+'"}}';
    return qs;
  }

  buildURI() {
    // uri con account id
    // let uri = (this.params.autocompleteURI != '' ? this.params.autocompleteURI : this.PARAMS.autocompleteURI );
    let uri = this.PARAMS.searchURI;
    // replace account id
    return uri.replace('{{accountId}}',this.params.accountId);
  }

  buildUrl() {
    let url = this.params.baseUrl + this.buildURI() + this.buildQS();
    // base url + uri + query params
    return url;
  }

  getYextFaq(input) {
    // context
    let ctx = this;
    // build final url
    let finalUrl = encodeURI(this.buildUrl() + '&input=' + input);
    // go fetch faq
    fetch(finalUrl)
      .then(res => res.json())
      .then(out => ctx.postProcessing(out.response,input))
      .catch(err => console.log(err));
  }

  postProcessing(results,input) {
    let payload = {};
    payload.faqs = results;
    payload.input = input;
    emit(CustomEvents.YEXT_EVENTS['faqsLoaded'],payload,this.SELECTORS.input);
  }

}

export default new YextFaqUtils();
